import other from './other'
import homeView from './homeView'
import productManagement from './productManagement'
import smartSystem from './smartSystem'
import newsViews from './newsViews'
import systemUser from './systemUser'
import webTemplate from './webTemplate'
import buyService from './buyService'

export default {
  other,
  homeView,
  productManagement,
  smartSystem,
  newsViews,
  systemUser,
  webTemplate,
  buyService,
}



// WEBPACK FOOTER //
// ./src/api/index.js